import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';
import { GoogleAuthProvider } from 'firebase/auth';

let firebaseConfig = {};

// Use REACT_APP_FIREBASE_ENV to distinguish between staging and production
// Falls back to NODE_ENV for backward compatibility
const firebaseEnv = (process.env.REACT_APP_FIREBASE_ENV || process.env.NODE_ENV) as string;

if (firebaseEnv === 'production') {
   firebaseConfig = {
      apiKey: 'AIzaSyAd09Wn5IILPsNEN4y9DXC9KNK1XVJbk90',
      authDomain: 'wetrippen-prod.firebaseapp.com',
      projectId: 'wetrippen-prod',
      storageBucket: 'wetrippen-prod.firebasestorage.app',
      messagingSenderId: '349934203656',
      appId: '1:349934203656:web:d2b5b09aeb2d50f04ef2bd',
      measurementId: 'G-W2VPT341MX',
      databaseId: 'wetrippen-prod',
   };
} else if (firebaseEnv === 'staging') {
   firebaseConfig = {
      apiKey: 'AIzaSyAAqoGmaGqF1DnmjLuqLrfsvDdO8_nEWNQ',
      authDomain: 'wetrippen-staging-b25aa.firebaseapp.com',
      projectId: 'wetrippen-staging-b25aa',
      storageBucket: 'wetrippen-staging-b25aa.firebasestorage.app',
      messagingSenderId: '803513873608',
      appId: '1:803513873608:web:0b8a53483e540f20bce1fd',
      measurementId: 'G-PQ3WP5Z7ZG',
      databaseId: 'wetrippen-staging-b25aa',
   };
} else {
   // Default to staging/development config for all other environments
   firebaseConfig = {
      apiKey: 'AIzaSyAukbCxBc1ZURBiS36xRG8u-p0kUnsAztA',
      authDomain: 'intenerarymap.firebaseapp.com',
      projectId: 'intenerarymap',
      storageBucket: 'gs://intenerarymap.firebasestorage.app',
      messagingSenderId: '411177923582',
      appId: '1:411177923582:web:aa4d9c012ccccc99ea86af',
      measurementId: 'G-3KMH6G9VJR',
      databaseId: 'intenerarymap',
   };
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);
const functions = getFunctions(app);
const provider = new GoogleAuthProvider();

// Add all required Google Photos scopes

provider.addScope('https://www.googleapis.com/auth/photoslibrary.readonly');
provider.addScope('https://www.googleapis.com/auth/photospicker.mediaitems.readonly');
provider.addScope('https://www.googleapis.com/auth/photoslibrary.readonly.appcreateddata');

provider.setCustomParameters({
   prompt: 'consent',
   access_type: 'offline',
});

export { app, db, storage, auth, functions, provider };
